<template>
    <div class="contract">
        <div class="contract-item" v-for="(item, index) in contractList" :key="index">
            <el-tooltip placement="top">
                <div slot="content">
                    <span v-if="item.tip">{{ item.tip }}</span>
                    <img v-if="item.hoverImg" :src="item.hoverImg" alt="">
                </div>
                <div>
                    <el-image class="contract-btn" :src="item.src" alt=""></el-image>
                    <img class="contract-btn-hover" :src="item.hoverSrc" alt="">
                </div>

            </el-tooltip>
        </div>
    </div>
</template>

<script>
export default {
    name: '',
    props: { source: String },
    data() {
        return {

        };
    },
    computed: {
        contractList() {
            let arr = [
                {
                    src: require('@/assets/images/contract/ic_phone_nor.svg'),
                    hoverSrc: require('@/assets/images/contract/ic_phone_nor-1.svg'),
                    tip: '400-883-5100'
                },
                {
                    src: require('@/assets/images/contract/ic_email_nor.svg'),
                    hoverSrc: require('@/assets/images/contract/ic_email_nor-1.svg'),
                    tip: 'ajiao.wang@enocare-china.com'
                },
                {
                    src: require('@/assets/images/contract/ic_wechat_nor.svg'),
                    hoverSrc: require('@/assets/images/contract/ic_wechat_nor-1.svg'),
                    hoverImg: require('@/assets/images/contract/img_wechat_qrcode.svg'),
                },
                {
                    src: require('@/assets/images/contract/ic_zhihu_nor.svg'),
                    hoverSrc: require('@/assets/images/contract/ic_zhihu_nor-1.svg'),
                    hoverImg: require('@/assets/images/contract/img_zhihu_qrcode.svg')
                },
            ]
            if (this.source && this.source == 'news') {
                arr.splice(2, 1)
            }
            return arr;
        }
    },
    watch: {
    },
    methods: {},
};
</script>

<style scoped lang="less">
.contract {
    display: flex;

    .contract-item {
        width: 44px;
        height: 44px;
        margin-right: 10px;
        position: relative;
        overflow: hidden;

        .contract-btn-hover {
            display: none;
            position: absolute;
            bottom: -10px;
        }

        &:hover {
            .contract-btn-hover {
                display: block;
                animation: moveUp 0.2s ease forwards;
            }
        }
    }
}

@keyframes moveUp {
    from {
        transform: translateY(0px);
    }

    to {
        transform: translateY(-10px);
    }
}
</style>
